import { object, string, number } from "yup";
import { Fragments } from "requests";

export const getValidation = (
  initialValues: Fragments.StoredPreAnestheticExam
) => {
  const positiveNumber = number()
    .transform(value => (Number.isNaN(value) ? 1 : value))
    .positive()
    .nullable();

  const validationSchema = object({
    temperature: positiveNumber,
    heartRate: positiveNumber,
    respiratoryRate: positiveNumber,
    painScore: number()
      .transform(value => (Number.isNaN(value) ? 1 : value))
      .min(0, "Pain Score must be positive")
      .nullable(),
    bodyConditionScore: number().nullable(),
    dentalScore: string().nullable(),
    physicalStatus: string().nullable()
  });

  return {
    validationSchema,
    defaultValues: {
      temperature: initialValues?.temperature || null,
      heartRate: initialValues?.heartRate || null,
      respiratoryRate: initialValues?.respiratoryRate || null,
      painScore:
        initialValues?.painScore === null
          ? null
          : (initialValues?.painScore as number),
      bodyConditionScore: initialValues?.bodyConditionScore || null,
      dentalScore:
        initialValues?.dentalScore === null
          ? null
          : String(initialValues?.dentalScore),
      physicalStatus: initialValues?.physicalStatus || null
    }
  };
};
